import Breadcrumb from '@/components/breadcrumb/breadcrumb';
import AvailableLanguages from '@/components/available-languages/available-languages';

export default {
	name: 'page-bar',
	props: {
		pages: {
			type: Array
		},
		languages: {
			type: Boolean,
			default: false
		}
	},
	components: {
		Breadcrumb,
		AvailableLanguages
	}
};



// WEBPACK FOOTER //
// ./sources/components/page-bar/index.js